import applicantDetailsImg from './applicant-details.png'
import jobsApplicantsListImg from './jobs-applicants-list.png'
import jobsPendingApplicantsReviewImg from './jobs-pending-applicants-review.png'

export const images = {
  applicantDetailsImg,
  jobsApplicantsListImg,
  jobsPendingApplicantsReviewImg,
}
